import { computed } from 'vue';
import useContent from '@/composables/useContent';
import { WEBSITE_CONTAINER_SIZES } from '@/js/constants';

export default function useWebsite() {
  const { currentContent } = useContent();

  const isWebsite = computed(() => currentContent.value?.type === 'elements.WEBSITE');
  const isNotFullsizeWebsite = computed(() => [
    WEBSITE_CONTAINER_SIZES.HALF_SIZE,
    WEBSITE_CONTAINER_SIZES.QUARTER_SIZE,
    WEBSITE_CONTAINER_SIZES.SQUARE_SIZE,
  ].includes(currentContent.value.attrs?.containerSize));

  return {
    isWebsite,
    isNotFullsizeWebsite,
  };
}
